// extracted by mini-css-extract-plugin
module.exports = {"title":"jSCsBVvw07Jc4lq070-fiw==","icon":"O-T27iKx9VRVioNOQS+7QA=="};